import { useLang } from "@/lib/i18n";
import { useSite } from "@/lib/site";

export default function Marquee() {
  const { L } = useLang();
  const site = useSite();
  const items = site?.settings?.marquee_items || [];

  const Row = ({ ariaHidden = false }) => (
    <div className="flex items-center shrink-0" aria-hidden={ariaHidden}>
      {items.map((item, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span className="font-head text-2xl md:text-4xl text-foreground/70 px-8 whitespace-nowrap">{L(item)}</span>
          <span className="inline-block h-2 w-2 rotate-45 bg-primary/70" aria-hidden="true" />
        </span>
      ))}
    </div>
  );

  return (
    <div data-testid="editorial-marquee" className="marquee overflow-hidden border-y border-border py-6 select-none">
      <div className="marquee-track">
        <Row />
        <Row ariaHidden />
      </div>
    </div>
  );
}
